import { TwoUpImageText } from "hec/components/2-up-image-text";

import type { RegisteredComponent } from "@builder.io/sdk-react";

export const TwoUpImageTextDefinition: RegisteredComponent = {
  component: TwoUpImageText,
  name: "TwoUpImageText",
  noWrap: true,
  inputs: [
    {
      name: "sectionTitle",
      type: "string",
      required: false,
      defaultValue: "",
    },
    {
      name: "image1Url",
      type: "file",
      allowedFileTypes: ["jpeg", "jpg", "png", "webp", "svg", "gif"],
      required: true,
      helperText: "Left image (brand/lifestyle)",
    },
    {
      name: "image1Alt",
      type: "string",
      required: true,
      helperText: "Alt text for left image (accessibility)",
      defaultValue: "",
    },
    {
      name: "image2Url",
      type: "file",
      allowedFileTypes: ["jpeg", "jpg", "png", "webp", "svg", "gif"],
      required: true,
      helperText: "Right image (product-in-use)",
    },
    {
      name: "image2Alt",
      type: "string",
      required: true,
      helperText: "Alt text for right image (accessibility)",
      defaultValue: "",
    },
    {
      name: "headline",
      type: "string",
      required: false,
      defaultValue: "Headline",
    },
    {
      name: "body",
      type: "richText",
      required: false,
      defaultValue: "<p>Body copy</p>",
    },
  ],
};
